// src/components/About.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const About = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>About Prarthana PU Science College</Typography>
      <Typography sx={{ mt: 2 }}>
        Prarthana PU College is a leading College in Bagalkot district offering bright future to the students.
      </Typography>
    </Container>
  );
};

export default About;
